import React from 'react';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { OnClick } from '@rbi-ctg/frontend';
import CloseButton from 'components/close-button';
import useMediaQuery from 'hooks/use-media-query';
import { portalToReplaceHeader } from 'state/mobile-header-nav';

import { IS_INVERTED } from './constants';
import { Header, Heading } from './styled';

const CloseButtonWrapper = styled.div`
  position: absolute;
  left: calc(1.25rem + env(safe-area-inset-left));
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface IFullPageScreenHeaderProps {
  heading: string;
  closeHref?: string;
  onClose?: OnClick;
  disableClose?: boolean;
  skipGoBackOnClose?: boolean;
}

const FullPageScreenHeader: React.FC<IFullPageScreenHeaderProps> = ({
  heading,
  closeHref,
  onClose,
  disableClose,
  skipGoBackOnClose = false,
}) => {
  const navigate = useNavigate();
  return (
    <Header>
      {!disableClose && (
        <CloseButtonWrapper>
          <CloseButton
            onClick={e => {
              if (onClose) {
                onClose(e);
              }

              if (closeHref) {
                navigate(closeHref);
                return;
              }

              if (!skipGoBackOnClose) {
                window.history.back();
              }
            }}
            inverted={IS_INVERTED}
          />
        </CloseButtonWrapper>
      )}
      <Heading>{heading}</Heading>
    </Header>
  );
};

const PortaledFullPageScreenHeader = portalToReplaceHeader(FullPageScreenHeader);

export default function PortaledHeader(props: IFullPageScreenHeaderProps) {
  const isMobile = useMediaQuery('mobile');

  return isMobile ? (
    <PortaledFullPageScreenHeader {...props} />
  ) : (
    <FullPageScreenHeader {...props} />
  );
}
